export default __webpack_public_path__ + "4bda684179d0da41bdd0c061bd4c4b00.png";